import { SvgIcon, SvgIconProps } from "@mui/material";

export const AddButtonIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="0.65"
    />
    <path
      d="M12 8V16M8 12H16"
      stroke="currentColor"
      strokeWidth="0.65"
      strokeLinecap="round"
    />
  </SvgIcon>
);
